module.exports = __webpack_public_path__ + "img/piano.ddeda1ac.jpg";